import React from "react";
import Typography from "@mui/material/Typography";
import { styled, useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PropTypes from "prop-types";
import { Link, Navigate } from "react-router-dom";
import { t } from "i18next";
import { utilities } from "../_helpers/utilities";
import { brandColors } from "../_components/brandedComponent/BrandedColors";
import Cookies from "universal-cookie";
import { LifeSafer } from "../_helpers/BrandConstants";
import useMediaQuery from "@mui/material/useMediaQuery";
import Divider from "@mui/material/Divider";
import { GreenButton } from "../_helpers/customMUI";
import GavelIcon from "@mui/icons-material/Gavel";
// import { useDeviceTypeWatcher } from "@/_helpers/PhoneNumberHelper";
import Person from "@mui/icons-material/Person";
import PersonalInjuryIcon from "@mui/icons-material/PersonalInjury";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const customIconVolunteerPropTypes = {
  baseSize: PropTypes.number,
  badgeWidth: PropTypes.number,
  badgeHeight: PropTypes.number,
  badgeTop: PropTypes.number,
  badgeRight: PropTypes.number,
  personSize: PropTypes.number,
  personMarginTop: PropTypes.number,
  footerWidth: PropTypes.number,
  footerHeight: PropTypes.number,
  footerTop: PropTypes.number,
  footerRight: PropTypes.number,
  stemWidth: PropTypes.number,
  stemHeight: PropTypes.number,
  stemTop: PropTypes.number,
  stemRight: PropTypes.number,
};

const PickAStory = () => {
  const cookies = new Cookies();
  const url = window.location.href;
  const theme = useTheme();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const langugeCode = localStorage?.getItem("i18nextLng");
  // const { phoneNumber } = useDeviceTypeWatcher();
  const CreditBox = styled(Grid)(() => ({
    minHeight: isTablet ? "100px" : "",
    width: "300px",
    minWidth: isTablet ? "" : "520px",
    maxHeight: "160px",
  }));
  const isISA = url.includes("lifesaferisa");
  const hiddenStoryCardKeys = ["guidance"];
  const isEuropeEnrollmentSite =
    window.location.hostname.toLowerCase().endsWith(".eu") ||
    String(process.env.REACT_APP_ENV || "").toLowerCase().startsWith("eu");

  if (isEuropeEnrollmentSite) {
    return <Navigate to="/story/europe" replace />;
  }

  const isaCards = [
    {
      storyKey: "courtOrdered",
      storyName: t("location.compliance"),
      iconStory: "GavelIcon",
      storyLink: "schedule",
      storyMessage: t("location.courtOrderedDescription"),
      buttonText: t("steps.scheduleNow"),
    },
    {
      storyKey: "volunteer",
      storyName: t("location.volunteer"),
      iconStory: "PersonalInjuryIcon",
      storyLink: "speed",
      storyMessage: t("location.volunteerDescription"),
      buttonText: t("location.getStarted"), 
    },
    {
      storyKey: "fleet",
      storyName: t("location.fleet"),
      iconStory: "LocalShippingIcon",
      storyLink: `https://www.lifesaferisa.com/fleets/schedule-now`,
      storyMessage: t("location.fleetDescription"),
      buttonText: t("speed.enrollNow"),
    },
  ];
  const defaultCards = [
    {
      storyKey: "schedule",
      storyName: t("steps.scheduleToday"),
      iconStory: "EventAvailableIcon",
      storyLink: "schedule",
      storyMessage: t("steps.scheduleMessage1"),
      buttonText: t("steps.scheduleNow"),
      isPadding: true,
    },
    {
      storyKey: "pricing",
      storyName: t("steps.buildAQuote"),
      iconStory: "ReceiptLongIcon",
      storyLink: "pricing",
      storyMessage: t("steps.buildAQuoteMessage"),
      buttonText: t("steps.getMyQuote"),
    },
    {
      storyKey: "location",
      storyName: t("steps.findALocation"),
      iconStory: "LocationOnIcon",
      storyLink: "location",
      storyMessage: t("steps.findALocationMessage"),
      buttonText: t("steps.findMyLocation"),
    },
    {
      storyKey: "guidance",
      storyName: t("steps.learnMore"),
      iconStory: "ManageSearchIcon",
      storyLink: "guidance",
      storyMessage: t("steps.learnMoreMessage"),
      buttonText: t("steps.learnMore"),
    },
  ];

  const CustomIconVolunteer = ({
    baseSize = 64,
    badgeWidth = 34,
    badgeHeight = 29,
    badgeTop = 30,
    badgeRight = 14,
    personSize = 33,
    personMarginTop = 9,
    footerWidth = 43,
    footerHeight = 12,
    footerTop = 25,
    footerRight = -3.25,
    stemWidth = 9,
    stemHeight = 20,
    stemTop = 25,
    stemRight = 6,
  }) => {
    return (
      <div style={{ position: "relative" }}>
        <PersonalInjuryIcon sx={{ color: "#fff", fontSize: baseSize }} />
        <div
          style={{
            backgroundColor: " rgb(255, 255, 255)",
            width: `${badgeWidth}px`,
            height: `${badgeHeight}px`,
            position: "absolute",
            top: `${badgeTop}px`,
            right: `${badgeRight}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "11.68px",
          }}
        >
          <Person
            sx={{
              color: "#1c355e",
              fontSize: personSize,
              zIndex: 10,
              mt: `${personMarginTop}px`,
            }}
          />
          <div
            style={{
              backgroundColor: " rgb(255, 255, 255)",
              width: `${footerWidth}px`,
              height: `${footerHeight}px`,
              position: "absolute",
              top: `${footerTop}px`,
              right: `${footerRight}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "16px",
            }}
          ></div>
          <div
            style={{
              backgroundColor: "#1c355e",
              width: `${stemWidth}px`,
              height: `${stemHeight}px`,
              position: "absolute",
              top: `${stemTop}px`,
              right: `${stemRight}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "14px",
            }}
          ></div>
        </div>
      </div>
    );
  };
  CustomIconVolunteer.propTypes = customIconVolunteerPropTypes;

  const cards = (isISA ? isaCards : defaultCards).filter(
    (card) => !hiddenStoryCardKeys.includes(card.storyKey),
  );
  const isPhoneLink = (link) => link?.startsWith("tel:");
  const getStoryPath = (link) =>
  /^https?:\/\//i.test(link)
    ? link
    : `/story/${utilities?.encodeStory(link)}`;

  const CustomCard = ({ storyName, iconStory, storyLink }) => (
    <Paper
      component={isPhoneLink(storyLink) ? "a" : Link}
      href={isPhoneLink(storyLink) ? storyLink : undefined}
      to={isPhoneLink(storyLink) ? undefined : getStoryPath(storyLink)}
      elevation={2}
      sx={{
        mt: 3,
        p: 2,
        textAlign: "left",
        height: 150,
        width: 150,
        // mx: "auto",
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <Paper
        sx={{
          height: "100%",
          width: "100%",
          boxShadow: "none",
        }}
      >
        <Grid container direction="column">
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              position: "relative",
              width: 120,
              height: 120,
            }}
          >
            {iconStory === "EventAvailableIcon" && (
              <EventAvailableIcon
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              />
            )}
            {iconStory === "LocationOnIcon" && (
              <LocationOnIcon
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              />
            )}
            {iconStory === "ManageSearchIcon" && (
              <ManageSearchIcon
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              />
            )}
            {iconStory === "ReceiptLongIcon" && (
              <ReceiptLongIcon
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              />
            )}
            {iconStory === "GavelIcon" && (
              <GavelIcon
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              />
            )}
            {iconStory === "PersonalInjuryIcon" && (
              <Grid
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              >
                <CustomIconVolunteer
                  baseSize={112}
                  badgeWidth={60}
                  badgeHeight={50}
                  badgeTop={24}
                  badgeRight={30}
                  personSize={140}
                  personMarginTop={0}
                  footerWidth={72}
                  footerHeight={20}
                  footerTop={43}
                  footerRight={-6}
                  stemWidth={24}
                  stemHeight={32}
                  stemTop={63}
                  stemRight={3}
                />
              </Grid>
            )}
            {iconStory === "LocalShippingIcon" && (
              <LocalShippingIcon
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: `${brandColors[brand].primary}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.1,
                }}
              />
            )}
            <Typography
              sx={{
                textAlign: "center",
                zIndex: 10,
                fontSize: 20,
                fontWeight: 600,
              }}
            >
              {storyName ?? "Story"}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Paper>
  );

  const CustomCardLaptop = ({
    storyName,
    iconStory,
    storyMessage,
    storyLink,
    buttonText,
    isPadding,
  }) => (
    <Paper
      elevation={2}
      sx={{
        textAlign: "center",
        minHeight:
          langugeCode === "es" ? (isISA ? 380 : 320) : isISA ? 320 : 300,
        width: 200,
        mt: 6,
        position: "relative",
        // mx: "auto",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          position: "absolute",
          top: -45,
          left: "50%",
          transform: "translateX(-50%)",
          height: 90,
          width: 90,
          bgcolor: "#1c355e",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9,
        }}
      >
        {iconStory === "EventAvailableIcon" && (
          <EventAvailableIcon sx={{ color: "#fff", fontSize: 64 }} />
        )}
        {iconStory === "LocationOnIcon" && (
          <LocationOnIcon sx={{ color: "#fff", fontSize: 64 }} />
        )}
        {iconStory === "ManageSearchIcon" && (
          <ManageSearchIcon sx={{ color: "#fff", fontSize: 64 }} />
        )}
        {iconStory === "ReceiptLongIcon" && (
          <ReceiptLongIcon sx={{ color: "#fff", fontSize: 64 }} />
        )}
        {iconStory === "GavelIcon" && (
          <GavelIcon sx={{ color: "#fff", fontSize: 64 }} />
        )}
        {iconStory === "PersonalInjuryIcon" && <CustomIconVolunteer />}
        {iconStory === "LocalShippingIcon" && (
          <LocalShippingIcon sx={{ color: "#fff", fontSize: 64 }} />
        )}
      </Paper>

      <Grid
        container
        direction="column"
        sx={{ mt: 7, px: langugeCode === "es" ? 0.5 : 1 }}
        alignItems="center"
      >
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 600,
            minHeight:
              langugeCode === "es" ? (isISA ? "60px" : "auto") : "auto",
            mt: 1,
            color: "#1C355E",
            px: langugeCode === "es" ? (isPadding ? 5 : 3) : 0,
          }}
        >
          {storyName}
        </Typography>

        <Divider sx={{ my: 1.5, width: "100%" }} />

        <Typography
          sx={{
            mb: langugeCode === "es" ? (isISA ? 0.5 : 1) : isISA ? 1 : 2,
            fontWeight: "500",
            fontSize: "18px",
            minHeight:
              langugeCode === "es"
                ? isISA
                  ? "170px"
                  : "110px"
                : storyName?.toLowerCase() === "fleet"
                  ? "134px"
                  : "110px",
            px: langugeCode === "es" ? 0.5 : isISA ? 1 : 2,
          }}
        >
          {storyMessage ?? t("help.emailUsMessage")}
        </Typography>
        <GreenButton
          component={isPhoneLink(storyLink) ? "a" : Link}
          href={isPhoneLink(storyLink) ? storyLink : undefined}
          to={isPhoneLink(storyLink) ? undefined : getStoryPath(storyLink)}
          size="medium"
          variant="contained"
          color="secondary"
          sx={{
            height: 36,
            fontWeight: 600,
            textTransform: "uppercase",
            fontSize: 13,
            lineHeight: 1.4,
            textDecoration: "none",
          }}
        >
          {buttonText}
        </GreenButton>
      </Grid>
    </Paper>
  );

  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "100px",
        marginBottom: "20px",
        mx: "auto",
      }}
    >
      <Grid
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <CreditBox
          style={{
            padding: 10,
            marginTop: 15,
            // border: `1px solid ${brandColors[brand].primary}`,
            borderRadius: 5,
            // backgroundColor: "aliceblue",
          }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {!isISA ? (
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "700",
                  fontSize: "22px",
                }}
              >
                {t("steps.pickAStoryMessage1")}
              </Typography>
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "700",
                  fontSize: "22px",
                }}
              >
                {t("location.situation")}
              </Typography>
            )}
          </Grid>
        </CreditBox>
        <Grid container sx={{ mt: isTablet ? 0 : 4 }}>
          {isTablet ? (
            <Grid
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "center",
                width: "100%",
              }}
            >
              {cards.map((card) => (
                <CustomCard
                  key={card.storyLink}
                  storyName={card.storyName}
                  iconStory={card.iconStory}
                  storyLink={card.storyLink}
                />
              ))}
            </Grid>
          ) : (
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                mx: "auto",
                gap: { xl: 6, md: 4 },
              }}
            >
              {cards.map((card) => (
                <CustomCardLaptop
                  key={card.storyLink}
                  storyName={card.storyName}
                  iconStory={card.iconStory}
                  storyLink={card.storyLink}
                  storyMessage={card.storyMessage}
                  buttonText={card.buttonText}
                  isPadding={card.isPadding}
                />
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

PickAStory.propTypes = {
  storyName: PropTypes.string.isRequired,
  iconStory: PropTypes.string.isRequired,
  storyLink: PropTypes.string.isRequired,
  storyMessage: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  isPadding: PropTypes.bool,
};
export default PickAStory;
